export default {
	methods: {
		goToRoute(event, route, params = {}, query = {}) {
			// Block event from right click
			if(event.button !== 2) {
				if(event.button === 1 || (event.button === 0 && event.ctrlKey)) {
					const target = this.$router.resolve({ name: route, params, query })
					window.open(target.href, '_blank')
				} else {
					this.$router.push({ name: route, params, query })
				}
			}
		}
	}
}
